import Reveal from 'components/ui/Reveal';
import brandStatementBg from '../../images/marketing/brand-statement-bg.webp';

export default function BrandStatement() {
  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20">
        <div className="max-w-4xl mx-auto text-center mb-10 sm:mb-14 lg:mb-20">
          <Reveal>
            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-singaraa-dark leading-tight mb-4 sm:mb-6">
              From Simple Peanuts to a <span className="text-singaraa-caramel italic">Better Way</span> of Snacking.
            </h2>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="font-body text-singaraa-dark/80 text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
              At Singaraa, we believe in elevating the familiar. We take the humble Indian peanut and transform it through careful dry roasting, retaining its natural oils and enhancing its innate crunch. No excess salt, no artificial coatings - just pure, premium snacking.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.4}>
          <div className="relative w-full h-[260px] sm:h-[340px] md:h-[440px] lg:h-[500px] rounded-2xl sm:rounded-3xl overflow-hidden bg-singaraa-beige shadow-2xl group">
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
              style={{ backgroundImage: `url(${brandStatementBg})` }}
            />
            {/* Elegant cinematic gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t sm:bg-gradient-to-r from-black/90 via-black/50 sm:via-black/35 to-transparent flex flex-col justify-end sm:justify-center p-6 sm:p-10 md:p-14 lg:p-16">
              <div className="max-w-xl">
                {/* Heritage Pill Badge */}
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-singaraa-peanut text-xs sm:text-sm font-medium tracking-widest uppercase mb-3 sm:mb-4">
                  <span className="w-1.5 h-1.5 rounded-full bg-singaraa-peanut animate-pulse" />
                  Authentic Heritage
                </div>

                {/* Decorative Quotation Mark */}
                <svg className="w-7 h-7 sm:w-9 sm:h-9 text-singaraa-peanut/70 mb-2 sm:mb-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>

                {/* Quote Typography */}
                <blockquote className="font-serif italic text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white font-normal leading-tight tracking-tight drop-shadow-md">
                  “The Taste Of <span className="text-singaraa-peanut not-italic font-semibold">Kathiyawad</span>”
                </blockquote>

                {/* Subtle Divider & Sub-tagline */}
                <div className="flex items-center gap-3 mt-3 sm:mt-4">
                  <div className="w-8 sm:w-12 h-[2px] bg-singaraa-caramel rounded-full" />
                  <p className="text-white/80 text-xs sm:text-sm md:text-base font-body font-light tracking-wide">
                    Authentic roasted crunch rooted in tradition.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
